
const reducer = (state = {}, action) => {
    switch (action.type) {
        case 'GET_CART_INFO_RESPONSE':
            return { ...state, getCartInfoSuccessResponse: action.data };

        case 'SET_CART_FMONTH_PRICE':
            return { ...state, cartFmonthPrice: action.data }

        case 'UPDATE_GET_CART_INFO_RESPONSE':
            return { ...state, getCartInfoSuccessResponse: action.data }
        
        case 'RESET_CART_INFO_RESPONSE':
            return { ...state, getCartInfoSuccessResponse: [] }
        
        case 'RESET_CART_FMONTH_PRICE' :
            return { ...state, cartFmonthPrice: 0 }
        
        default:
            return state;
    }
};

export default reducer;